<div class="panel-heading" role="tab" id="heading_{{key}}">
  <div class="row">
    <div class="col-xs-6">
      <h4 class="panel-title">
        <a role="button" id="collapse_{{key}}" data-toggle="collapse" data-parent="#accordion" href="#panel_{{key}}" aria-expanded="true" aria-controls="collapse_{{key}}">
          {{t title}}
        </a>
      </h4>
    </div>
    <div class="col-xs-6">
      <div class="pull-right">
        {{#if completed}}
          <button class="btn btn-xs btn-primary" disabled="disabled">Module Complete</button>
        {{else}}
          <button class="btn btn-xs btn-success progress-grant-all" data-module="{{key}}">Grant Progress</button>
        {{/if}}
        {{#if local}}
          <button class="btn btn-xs btn-danger progress-remove-all" data-module="{{key}}">Clear Progress</button>
        {{/if}}
      </div>
    </div>
  </div>
</div>
<div id="panel_{{key}}" class="panel-collapse collapse {{#if wasOpen}}in{{/if}}" role="tabpanel" aria-labelledby="heading_{{key}}">
  <div class="panel-body">
    <table class="table table-bordered table-striped table-condensed">
      <tr>
        <th>Activity Key</th>
        <th>Page Key</th>
        <th>Complete</th>
        <th></th>
      </tr>
      {{#each activities}}
        {{#each pages}}
          <tr>
            <td>{{../key}}</td>
            <td><a href="#{{../../key}}/{{../key}}/{{key}}" data-close="true">{{key}}</a></td>
            <td>{{completed}}</td>
            <td>
              {{#if completed}}
                {{#if ../../local}}
                  <button class="btn btn-xs btn-progress btn-danger" data-module="{{../../key}}" data-activity="{{../key}}"
                          data-page="{{key}}">Remove</button>
                {{else}}
                  <button class="btn btn-xs btn-primary" disabled="disabled">Complete</button>
                {{/if}}
              {{else}}
                <button class="btn btn-xs btn-progress btn-success" data-module="{{../../key}}" data-activity="{{../key}}"
                        data-page="{{key}}">Add</button>
              {{/if}}
            </td>
          </tr>
        {{/each}}
      {{/each}}
    </table>
  </div>
</div>
